import React, { useState, useEffect } from "react";
import { Modal, Input, Checkbox, Button, Row, Col, Form } from "antd";
import { framoData } from "../../../../../Data/data";

const AddFramoDetailsModal = ({ visible, onOk, onCancel, responseData, errors }) => {
  const [form] = Form.useForm();
  const [selectedParams, setSelectedParams] = useState([]);
  const [customParams, setCustomParams] = useState([]);

  // Collect all parameters from all sections in framoData
  const allParameters = framoData.reduce((acc, section) => {
    return acc.concat(section.parameters);
  }, []);

  useEffect(() => {
    try {
      const allParameters = framoData.reduce((acc, section) => acc.concat(section.parameters), []);
      const defaultParams = responseData?.selected_parameters || allParameters; // Auto select all if no responseData
      setSelectedParams(defaultParams);

      if (responseData) {
        form.setFieldsValue({
          framo_name: responseData?.framo_name || "",
          framo_maker: responseData?.framo_maker || "",
          framo_model: responseData?.framo_model || "",
        });
        setCustomParams(
          Array.isArray(responseData?.other_parameters) ? responseData.other_parameters : []
        );
      } else {
        form.resetFields();
        setCustomParams([]);
      }
    } catch (error) {
      console.error("Error setting responseData:", error);
    }
  }, [responseData, form]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      const fieldErrors = Object.keys(errors).map((key) => ({
        name: key,
        errors: [errors[key]],
      }));
      form.setFields(fieldErrors);
    }
  }, [errors, form]);

  const handleAddParam = () => {
    setCustomParams([...customParams, { name: "", unit: "" }]);
  };

  const handleCustomChange = (index, field, value) => {
    const updated = [...customParams];
    updated[index][field] = value;
    setCustomParams(updated);
  };

  const handleDeleteParam = (index) => {
    setCustomParams(customParams.filter((_, i) => i !== index));
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const data = {
          ...values,
          selectedParams,
          customParams,
        };
        onOk(data);
        form.resetFields();
        setSelectedParams([]);
        setCustomParams([]);
      })
      .catch((errorInfo) => {
        console.log("Validation Failed:", errorInfo);
      });
  };

  const handleCheckbox = (item) => {
    if (selectedParams.includes(item)) {
      setSelectedParams(selectedParams.filter((param) => param !== item));
    } else {
      setSelectedParams([...selectedParams, item]);
    }
  };

  const renderParameters = (parameters) => (
    <Row gutter={16}>
      <Col span={12}>
        {parameters.slice(0, Math.ceil(parameters.length / 2)).map((item, index) => (
          <div key={index}>
            <Checkbox checked={selectedParams.includes(item)} onChange={() => handleCheckbox(item)}>
              {item}
            </Checkbox>
          </div>
        ))}
      </Col>
      <Col span={12}>
        {parameters.slice(Math.ceil(parameters.length / 2)).map((item, index) => (
          <div key={index}>
            <Checkbox checked={selectedParams.includes(item)} onChange={() => handleCheckbox(item)}>
              {item}
            </Checkbox>
          </div>
        ))}
      </Col>
    </Row>
  );

  const renderCustomParameters = () => (
    <div style={{ marginTop: 16 }}>
      <b>Add Other Parameters</b>
      {customParams.map((param, index) => (
        <Row gutter={8} key={index} style={{ marginTop: 8 }}>
          <Col span={10}>
            <Input
              placeholder="Parameter"
              value={param.name}
              maxLength={50}
              onChange={(e) => handleCustomChange(index, "name", e.target.value)}
            />
          </Col>
          <Col span={10}>
            <Input
              placeholder="Unit"
              value={param.unit}
              maxLength={10}
              onChange={(e) => handleCustomChange(index, "unit", e.target.value)}
            />
          </Col>
          <Col span={4}>
            <Button danger onClick={() => handleDeleteParam(index)} block>
              ×
            </Button>
          </Col>
        </Row>
      ))}
      <Button type="dashed" onClick={handleAddParam} style={{ marginTop: 12 }}>
        + Add Parameter
      </Button>
    </div>
  );

  return (
    <Modal
      title="Add Framo Details"
      visible={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      okText="Save"
    >
      <Form
        layout="vertical"
        form={form}
        onValuesChange={(changedValues) => {
          Object.keys(changedValues).forEach((key) => {
            form.setFields([{ name: key, errors: [] }]);
          });
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item label="framo Name" name="framo_name" rules={[{ required: true }]}>
              <Input placeholder="framo Name" maxLength={50} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="framo Maker" name="framo_maker">
              <Input placeholder="framo Maker" maxLength={50} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="framo Model" name="framo_model">
              <Input placeholder="framo Model" maxLength={50} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Select Parameters">{renderParameters(allParameters)}</Form.Item>
          </Col>

          <Col span={24}>{renderCustomParameters()}</Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddFramoDetailsModal;
